import cn from 'classnames';
import React from 'react';

import styles from './styles.module.scss';

export const ErrorBlock: React.FC<React.HTMLProps<HTMLDivElement>> = ({ className, ...props }) => (
  <div {...props} className={cn(styles.error_block, className)} />
);
